import { inject, Injectable } from '@angular/core';
import { BrowserApiSupportService } from '@lentau/ui-kit/core/services/browser-api-support/browser-api-support.service';
import { ScrollPositionRestorationService, StickyQueryParamsService } from '@lentau/core/route';
import { InitGrowthBookService } from '@lentau/core/growth-book/application/init-growth-book.service';
import { CityService } from '@lentau/city/application/city.service';
import { InitMpkService } from '@lentau/mpk/application/services/init-mpk.service';
import { CacheBootstrapService } from './cache-bootstrap.service';
import { AppResumeLifecycleService } from '@lentau/core/runtime-recovery/application/lifecycle/app-resume-lifecycle.service';
import { SwResumeHealthcheckService } from '@lentau/core/runtime-recovery/application/orchestration/sw-resume-healthcheck.service';
import { ServiceWorkerUpdateService } from '@lentau/core/service-worker/application/sw.update.service';
import { ClientReloadPolicyService } from '@lentau/core/runtime-recovery/application/config/client-reload-policy.service';
import { AuthTokenService } from '@lentau/auth/application/services/auth-token.service';
import { isSocialAuthCallbackPath } from '@lentau/auth/shared';
import { AuthFacade } from '@lentau/auth/store';
import { WINDOW } from '@lentau/ui-kit/core/tokens/window';

@Injectable({
  providedIn: 'root',
})
export class EagerCommonBootstrapCSRService {
  private readonly browserApi: BrowserApiSupportService = inject(BrowserApiSupportService);
  private readonly initMpkService: InitMpkService = inject(InitMpkService);
  private readonly scrollPositionRestorationService: ScrollPositionRestorationService = inject(
    ScrollPositionRestorationService
  );
  private readonly stickyQueryParamsService: StickyQueryParamsService = inject(StickyQueryParamsService);
  private readonly cityService: CityService = inject(CityService);
  private readonly initGrowthBookService: InitGrowthBookService = inject(InitGrowthBookService);
  private readonly cacheBootstrapService: CacheBootstrapService = inject(CacheBootstrapService);
  private readonly appResumeLifecycleService: AppResumeLifecycleService = inject(AppResumeLifecycleService);
  private readonly swResumeHealthcheckService: SwResumeHealthcheckService = inject(SwResumeHealthcheckService);
  private readonly serviceWorkerUpdateService: ServiceWorkerUpdateService = inject(ServiceWorkerUpdateService);
  private readonly clientReloadPolicyService: ClientReloadPolicyService = inject(ClientReloadPolicyService);
  private authTokenService: AuthTokenService = inject(AuthTokenService);
  private authFacade: AuthFacade = inject(AuthFacade);
  private readonly window: Window = inject(WINDOW);

  public init(): void {
    // Отслеживание возобновления приложения из фона
    this.appResumeLifecycleService.init();
    // Проверка, нужно ли обновлять сервис-воркер при возобновлении приложения из фона
    this.swResumeHealthcheckService.init();
    // Обновление приложения при устаревшем сервис-воркере при старте приложения
    if (this.clientReloadPolicyService.isSwAppInitEnabled()) {
      void this.serviceWorkerUpdateService.update('app_init');
    }

    this.cacheBootstrapService.initAlways();

    this.initGrowthBookService.init();

    // Social OAuth callback: guest sessionGet would race validate and log the user out;
    // also drop guest profile/mission caches so null→B2C can wake AddressesRequestService (WEB-2294).
    if (isSocialAuthCallbackPath(this.window.location.pathname)) {
      this.cacheBootstrapService.clearSessionCaches();
    } else {
      this.cacheBootstrapService.hydrateSessionCaches();
      this.authFacade.sessionGet();
    }

    // Формирование МПК, новая и старая логика
    this.initMpkService.init();

    this.cityService.init();

    this.browserApi.listenForWindowLoadEvent();

    this.scrollPositionRestorationService.initScroll();

    this.stickyQueryParamsService.init();

    this.authTokenService.init();
  }
}
